function logtoLataLayer(data) {
  if (!window.dataLayer) {
    window.dataLayer = [];
  }

  window.dataLayer.push(data);
}

const logToExponea = (data) => {
  if (!window.exponea) {
    return;
  }

  window.exponea?.track('search', data);
};

export default () => (next) => (action) => {
  if (!action.meta) {
    return next(action);
  }

  if (action.meta.exponea) {
    logToExponea(action.meta.exponea);
  }

  if (action.meta.gtm) {
    if (typeof action.meta.gtm === 'string' || typeof action.meta.gtm === 'number') {
      logtoLataLayer({ event: action.meta.gtm });
    } else {
      logtoLataLayer(action.meta.gtm);
    }
  }

  return next(action);
};
